import React from 'react'

import { Box, Stack, SxProps, Theme } from '@mui/material'

import { connectorUtils } from '@/utils/connector'

const ICON_SIZE = 22

interface ConnectorIconsProps {
  connectorTypes: string[]
  sx?: SxProps<Theme>
}

const ConnectorIcons: React.FC<ConnectorIconsProps> = ({ connectorTypes, sx }) => {
  const icons = connectorTypes.filter(connectorUtils.hasIcon)

  if (icons.length === 0) return null

  return (
    <Stack direction="row" alignItems="center" spacing={0.75} sx={{ flexShrink: 0, ...sx }}>
      {icons.map((connectorType, index) => (
        <Box
          component="img"
          key={`${connectorType}-${index}`}
          src={connectorUtils.getIconSrc(connectorType) ?? undefined}
          alt={connectorUtils.getLabel(connectorType)}
          sx={{ width: ICON_SIZE, height: ICON_SIZE, display: 'block' }}
        />
      ))}
    </Stack>
  )
}

export default ConnectorIcons
